import AccountLogin from './account-login.vue';

const loadPromise = new Promise((resolve) => {
    vueApp.component('account-login', AccountLogin);
    resolve();
});

window.pendingComponentLoads.push(loadPromise);
